import constraints from '../../constraints';
import getElementFromNode from '../helpers/get-element-from-node';

const hasContentEditableAncestor = (node) => {
  const ROOT_SELECTORS = constraints.accessors.getContentEditableRootSelector();

  const element = getElementFromNode(node);
  const contentEditableSelectors = ROOT_SELECTORS.map((selector) => `${selector}[contenteditable]`);
  return Boolean(element.closest(contentEditableSelectors));
};

export default hasContentEditableAncestor;
